import React, { useEffect, useState } from "react";
import { Calculator, Loader2 } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useAuth } from "../context/AuthContext";
import { DashboardLayout } from "../components/layout/DashboardLayout";
import { COLORS } from "../utils/constants";
import { ContratForm } from "../components/simulateur/ContratForm";
import { ResumeCards } from "../components/simulateur/ResumeCards";
import { AnneeImpact } from "../components/simulateur/AnneeImpact";
import { EcheancierTable } from "../components/simulateur/EcheancierTable";
import { TvaImpact } from "../components/simulateur/TvaImpact";

const moisCourant = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const SimulateurPage = () => {
  const api = useApi();
  const { user } = useAuth();
  const [form, setForm] = useState({ mode: "total", montant: 3000, nb_mois: 6, mois_debut: moisCourant(), activite: "principal" });
  const [sim, setSim] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const montant = Number(form.montant);
    const nb = Math.min(36, Math.max(1, Number(form.nb_mois) || 1));
    if (!montant || montant <= 0 || !form.mois_debut) { setSim(null); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      setError("");
      try {
        const r = await api.post("/simulateur/contrat", { ...form, montant, nb_mois: nb });
        setSim(r.data);
      } catch {
        setError("Impossible de calculer la simulation pour le moment.");
      }
      setLoading(false);
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return (
    <DashboardLayout>
      <div className="flex flex-col gap-6 max-w-6xl pt-2" data-testid="simulateur-page">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold flex items-center gap-2" style={{ color: COLORS.text }}>
            <Calculator size={26} /> Mon Simulateur de contrat
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Un client te propose un contrat ? Vois ce qu'il te rapporte vraiment et son effet sur tes seuils, ta retraite et ta CFE, en partant de ton CA actuel.
          </p>
        </div>
        <ContratForm form={form} setForm={setForm} hasDouble={!!user?.double_activite} minMois={moisCourant()} />
        {loading && !sim && <div className="flex justify-center py-10"><Loader2 className="animate-spin" style={{ color: COLORS.accent }} /></div>}
        {error && <p className="text-sm" style={{ color: COLORS.error }} data-testid="simulateur-error">{error}</p>}
        {sim && (
          <div className={`flex flex-col gap-8 transition-opacity ${loading ? "opacity-60" : ""}`} data-testid="simulateur-resultats">
            <ResumeCards sim={sim} />
            <TvaImpact t={sim.tva_impact} />
            {sim.annees.map((a) => <AnneeImpact key={a.annee} a={a} />)}
            <EcheancierTable sim={sim} />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default SimulateurPage;
